import { edi } from '@/requests';
import { postRequest } from '@/core';

export default async function sentTripOnEdiRequest(id) {
	let url = edi.sendTripOnEdiPath(id);
	let response = await postRequest(url, {}, {});
	return response;
}